import { render, staticRenderFns } from "./upcoming-lectures-component.vue?vue&type=template&id=11435bd2&scoped=true"
import script from "./upcoming-lectures-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./upcoming-lectures-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./upcoming-lectures-component.vue?vue&type=style&index=0&id=11435bd2&prod&scoped=true&lang=css"
import style1 from "./upcoming-lectures-component.vue?vue&type=style&index=1&id=11435bd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11435bd2",
  null
  
)

export default component.exports